import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { ABOUT_IMAGE, CONTACT } from "@/data/content";
import { useLanguage } from "@/i18n/LanguageContext";

export default function About() {
  const { t } = useLanguage();
  return (
    <section
      id="apropos"
      data-testid="about-section"
      className="py-20 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            className="relative"
          >
            <div className="absolute -top-4 -left-4 w-24 h-24 border-t-2 border-l-2 border-[#E31E24]" />
            <div className="absolute -bottom-4 -right-4 w-24 h-24 border-b-2 border-r-2 border-[#E31E24]" />
            <div className="overflow-hidden">
              <motion.img
                src={ABOUT_IMAGE}
                alt="ACOMEP"
                loading="lazy"
                initial={{ scale: 1.12 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.2, ease: [0.16, 1, 0.3, 1] }}
                className="w-full aspect-[4/3] object-cover"
              />
            </div>
            <div className="absolute bottom-6 left-6 bg-white px-5 py-4 shadow-xl border-l-4 border-[#E31E24]">
              <div className="font-mono-tech text-[10px] tracking-[0.25em] uppercase text-slate-500">
                {t.about.badgeLabel}
              </div>
              <div className="font-display font-bold text-slate-900">
                {t.about.badgeValue}
              </div>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7 }}
          >
            <div className="font-mono-tech text-xs uppercase tracking-[0.25em] text-[#E31E24] font-semibold mb-4">
              {t.about.overline}
            </div>
            <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-slate-900">
              {t.about.title}
            </h2>
            <p className="mt-6 text-base sm:text-lg text-slate-600 leading-relaxed">
              {t.about.p1}
            </p>
            <p className="mt-4 text-base text-slate-600 leading-relaxed">
              {t.about.p2}
            </p>

            <div className="mt-8 flex flex-wrap gap-3" data-testid="about-regions">
              {t.about.regions.map((r) => (
                <span
                  key={r}
                  className="inline-flex items-center gap-2 border border-slate-200 bg-slate-50 px-4 py-2 text-sm font-medium text-slate-700"
                >
                  <MapPin size={14} className="text-[#E31E24]" />
                  {r}
                </span>
              ))}
            </div>

            <div className="mt-10 pt-8 border-t border-slate-200 flex flex-wrap gap-x-10 gap-y-4 font-mono-tech text-xs tracking-[0.15em] uppercase text-slate-500">
              <span>{CONTACT.tva}</span>
              <span>{CONTACT.email}</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
